export default __webpack_public_path__ + "static/gary1-7d6b8949da31e826e8648d571fb44689.jpg";